export default "__VITE_ASSET__C4nxXzC7__"